import { Stack } from '@mui/material';
import { Box } from '@mui/system';
import { IDisabilitySections } from 'API/personalDetails';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Clause } from './Clause';
import { PreviousConsideredPercent } from './PreviousConsideredPercent';

export interface IDisabilityClause {
  clause: IDisabilitySections;
}

export const DisabilityClause = ({ clause }: IDisabilityClause) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  const clauses = [
    {
      title: dictionary.disabilityInformation.disabilityPercent,
      info: clause?.considerPercent,
    },
    {
      title: dictionary.disabilityInformation.dateValidity,
      info: clause?.sectionValidTo,
    },
  ];

  return (
    <Stack
      gap={isDesktop ? '40px' : '20px'}
      direction={isDesktop ? 'row' : 'column'}
    >
      <Stack width={isDesktop ? '210px' : '100%'} flexShrink={0}>
        <Clause
          title={dictionary.disabilityInformation.healthState}
          information={clause?.sectionDescription}
        />
      </Stack>
      <Stack
        direction={'row'}
        flexWrap={'wrap'}
        gap={isDesktop ? '40px' : '20px'}
      >
        {clauses.map((clause, index) => (
          <Stack width={'136px'} gap={'24px'} key={index}>
            <Clause title={clause.title} information={clause.info} />
          </Stack>
        ))}
        {clause?.nonConsiderPercent &&
          Math.floor(Number(clause?.nonConsiderPercent)) > 0 && (
            <PreviousConsideredPercent
              previousConsideredPercent={clause?.nonConsiderPercent}
            />
          )}
      </Stack>
    </Stack>
  );
};
